<template>
    <div id="Editor-task">
        <div class="editor-task">
            <div class="editor-task-header">
                <a-select class="editor-task-todo-select" placeholder="ToDo">
                    <a-select-option value="ToDo">To Do</a-select-option>
                    <a-select-option value="Compledet">Compledet</a-select-option>
                    <a-select-option value="In">In</a-select-option>
                    <a-select-option value="Done">Done</a-select-option>
                </a-select>
                <a-button class="editor-re-open-btn" block>
                    <span class="md-icon" style="margin-right: 3px">restart_alt</span>
                    Re-Open
                </a-button>
            </div>
            <div class="editor-task-content">
                <div class="editor-task-quill-editor">
                    <quill-editor
                        style="max-height: 20%; width: 100%"
                        v-model="form.description"
                        class="quill-editor"
                        :options="editorOption"
                        placeholder="Task Description"
                    />
                </div>
                <div class="editor-task-new-checklist">
                    <div class="checklist-data">
                        <div style="display: flex; align-items: center; gap: 20px" v-if="form.checklist.length > 0">
                            <div style="font-weight: bold; font-size: 16px; margin-right: 20px">Checklist</div>
                            <div style="width: 200px">
                                <a-progress
                                    :stroke-color="{
                                        '0%': 'ec4b1d',
                                        '100%': 'ec4b1d',
                                    }"
                                    :percent="
                                        (100 / form.checklist.length) *
                                        form.checklist.filter((c) => c.isCompleted).length
                                    "
                                    :show-info="false"
                                />
                            </div>
                            <div style="width: 200px">
                                Completed: {{ form.checklist.filter((c) => c.isCompleted).length }} out of
                                {{ form.checklist.length }}
                            </div>
                        </div>
                        <div style="margin-top: 10px; display: flex; gap: 10px; flex-direction: column">
                            <div
                                style="
                                    display: flex;
                                    align-items: center;
                                    justify-content: flex-start;
                                    user-select: none;
                                "
                                v-for="(checkbox, index) of form.checklist"
                            >
                                <div style="display: flex; align-items: center; gap: 10px">
                                    <a-checkbox class="kanban-checkbox large" v-model="checkbox.isCompleted" />
                                    <input
                                        style="
                                            width: 300px;
                                            border: none;
                                            outline: none;
                                            background: #f1f1f1;
                                            border-radius: 4px;
                                            padding: 3px 10px;
                                        "
                                        v-model="checkbox.title"
                                    />
                                </div>
                                <div class="material-icons" @click="deleteCheckbox(index)">close</div>
                            </div>
                        </div>
                        <div
                            style="margin-top: 10px; color: #ec4b1d; font-weight: bold; cursor: pointer"
                            @click="addNewCheckBox"
                        >
                            {{ !form.checklist.length ? "New Checklist" : "Add" }}
                        </div>
                    </div>
                </div>
                <div class="editor-task-attach-files">
                    <div class="attach-files">
                        <div class="text">
                            <div class="material-icons">attachment</div>
                            <div>Attach Files</div>
                        </div>
                        <div class="logo">
                            <s3Logo />
                        </div>
                    </div>
                </div>
                <div class="editor-task-new-subtask">
                    <div
                        style="margin-top: 10px; display: flex; gap: 10px; flex-direction: column"
                        v-if="form.subTasks.length > 0"
                    >
                        <div v-for="(subtask, index) of form.subTasks">
                            <div
                                v-if="!subtask.isExits"
                                style="
                                    display: flex;
                                    align-items: center;
                                    justify-content: space-between;
                                    user-select: none;
                                    gap: 20px;
                                "
                            >
                                <div style="display: flex; align-items: center; gap: 10px; width: 100%">
                                    <a-checkbox class="kanban-checkbox large" v-model="subtask.completed" />
                                    <a-input
                                        class="classic-new-input"
                                        v-model:value="subtask.title"
                                        placeholder="SubTask Title"
                                    />
                                </div>
                                <div style="width: 100%">
                                    <a-select
                                        style="width: 100%"
                                        class="select-multiple"
                                        v-model:value="subtask.assignees"
                                        :options="users"
                                        placeholder="Assignee"
                                    ></a-select>
                                </div>
                                <div class="material-icons" @click="deleteSubtask(index)">close</div>
                            </div>
                            <div
                                style="
                                    display: flex;
                                    align-items: center;
                                    justify-content: space-between;
                                    user-select: none;
                                    gap: 20px;
                                "
                                v-else
                            >
                                <div style="width: 100%">
                                    <a-select
                                        style="width: 100%"
                                        class="select-multiple"
                                        v-model:value="subtask.taskId"
                                        :options="users"
                                        placeholder="Assignee"
                                    ></a-select>
                                </div>
                                <div class="material-icons" @click="deleteSubtask(index)">close</div>
                            </div>
                        </div>
                    </div>
                    <div class="row gap-10">
                        <div
                            style="margin-top: 10px; color: #ec4b1d; font-weight: bold; cursor: pointer"
                            @click="addNewSubtask(false)"
                        >
                            {{ "Add Subtasks" }}
                        </div>
                        <div
                            style="margin-top: 10px; color: #ec4b1d; font-weight: bold; cursor: pointer"
                            @click="addNewSubtask(true)"
                        >
                            {{ "Add Exits Subtasks" }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="editor-info">
            <div class="info-task-list">
                <div class="info-task-item">
                    <label>Start Date</label>
                    <div class="info-task-item-value">
                        <a-date-picker v-model:value="form.startDate" />
                    </div>
                </div>
                <div class="info-task-item">
                    <label>End Date</label>
                    <div class="info-task-item-value">
                        <a-date-picker v-model:value="form.endDate" />
                    </div>
                </div>
                <div class="info-task-item">
                    <label>Priority</label>
                    <div class="info-task-item-value">
                        <a-select v-model:value="form.priority" style="width: 167px">
                            <a-select-option value="low">Low</a-select-option>
                            <a-select-option value="medium">Medium</a-select-option>
                            <a-select-option value="high">High</a-select-option>
                        </a-select>
                    </div>
                </div>
                <div class="info-task-item">
                    <label>Owner</label>
                    <div class="info-task-item-value">
                        <a-select
                            style="width: 167px"
                            class="select-multiple"
                            v-model:value="form.owner"
                            :options="users"
                            placeholder="Owner"
                        ></a-select>
                    </div>
                </div>
                <div class="info-task-item">
                    <label>Assignee</label>
                    <div class="info-task-item-value">
                        <a-select
                            style="width: 167px"
                            class="select-multiple"
                            v-model:value="form.assignees"
                            :options="users"
                            placeholder="Owner"
                        ></a-select>
                    </div>
                </div>
                <!--                şimdilik bu özellik bizde olmayacak-->
                <!--                <div class="info-task-item">-->
                <!--                    <label>Task List</label>-->
                <!--                    <div class="info-task-item-value">Task Listesi gelecek</div>-->
                <!--                </div>-->
                <div class="info-task-item">
                    <label>Completed Date</label>
                    <!--                    şuan için completed tarihi mevcut değil data içinde -->
                    <div class="info-task-item-value">01.05.2024 5:41 am</div>
                </div>
                <div class="info-task-item">
                    <label>Task ID</label>
                    <div class="info-task-item-value">{{ form._id }}</div>
                </div>
                <div class="info-task-item">
                    <label>Created</label>
                    <div class="info-task-item-value">{{ form.createdAt }}</div>
                </div>
                <div class="info-task-item">
                    <label>Last Updated</label>
                    <div class="info-task-item-value">3 days ago</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import s3Logo from "../svg/S3.vue";
import { mapActions, mapState } from "vuex";

export default {
    name: "EditorTask",
    components: { s3Logo },
    props: {
        details: {
            type: Object,
        },
    },
    data() {
        return {
            form: {
                title: null,
                description: null,
                priority: "low",
                checklist: [],
                assigneeIds: [],
                ownerId: null,
                collaboratorIds: [],
                followerIds: [],
                subTasks: [],
                startDate: null,
                endDate: null,
                workflowId: null,
                pipelineStageId: null,
                color: null,
                createdAt: null,
            },
            editorOption: {
                theme: "snow",
                modules: {
                    toolbar: [
                        ["bold", "italic", "underline", "strike"],
                        [{ header: [1, 2, 3, 4, 5, 6, false] }],
                        [{ color: [] }, { background: [] }],
                        [{ align: [] }],
                        [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
                        ["link"],
                    ],
                },
            },
        };
    },
    computed: {
        ...mapState({
            users: (state) =>
                state.user.users.data.reduce((acc, user) => {
                    acc.push({
                        value: user._id,
                        label: user.name,
                    });
                    return acc;
                }, []),
            defaultWorkflow: (state) => state.tasks.defaultWorkflow,
        }),
    },
    methods: {
        ...mapActions({
            getTaskDetail: "tasks/getTaskDetail",
        }),
        addNewCheckBox() {
            if (
                this.form.checklist[this.form.checklist.length - 1] &&
                !this.form.checklist[this.form.checklist.length - 1].title
            ) {
                this.form.checklist = this.form.checklist.slice(0, this.form.checklist.length - 1);
            } else {
                this.form.checklist = [
                    ...this.form.checklist,
                    {
                        isCompleted: false,
                        title: null,
                    },
                ];
            }
        },
        deleteCheckbox(index) {
            this.form.checklist = this.form.checklist.filter((c, i) => i !== index);
        },
        addNewSubtask(isExits) {
            if (
                this.form.subTasks[this.form.subTasks.length - 1] &&
                (this.form.subTasks[this.form.subTasks.length - 1].isExits
                    ? !this.form.subTasks[this.form.subTasks.length - 1].taskId
                    : !this.form.subTasks[this.form.subTasks.length - 1].title)
            ) {
                this.form.subTasks = this.form.subTasks.slice(0, this.form.subTasks.length - 1);
            } else {
                this.form.subTasks = [
                    ...this.form.subTasks,
                    isExits
                        ? {
                              isExits,
                              taskId: null,
                          }
                        : {
                              completed: false,
                              assignees: this.users[0]?.value,
                              title: null,
                          },
                ];
            }
        },
        deleteSubtask(index) {
            this.form.subTasks = this.form.subTasks.filter((c, i) => i !== index);
        },
        CreatedDate() {
            const date = this.moment(this.form.createdAt).format("DD.MM.YYYY HH:mm");
            return date;
        },
    },
    mounted() {
        this.getTaskDetail(this.details.taskId).then((data) => {
            console.log("data geldi", {
                data,
            });
            this.form = data;
        });
    },
    watch: {
        form: {
            handler(val) {
                this.$emit("update-form", this.form);
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss">
#Editor-task {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    margin-top: -20px;

    .editor-task {
        width: 70%;
        height: 100%;
        background-color: #fff;

        .editor-task-header {
            width: 95%;
            height: auto;
            background-color: #fff;
            border-bottom: 1px solid #dddddd;
            display: flex;
            align-items: center;
            padding: 0 20px;
            font-size: 16px;
            font-weight: 500;
            color: #333333;

            .editor-task-todo-select {
                width: 200px !important;
                height: 70px !important;
                margin-bottom: -20px !important;
                margin-top: 20px !important;
            }

            .editor-re-open-btn {
                width: 110px !important;
                margin-left: 15px;
            }
        }

        .editor-task-content {
            width: 100%;
            height: calc(100% - 50px);
            background-color: #fff;
            padding: 20px;

            .editor-task-quill-editor {
                width: 100%;
                height: 100%;
                background-color: #fff;
                border: 1px solid #dddddd;
                border-radius: 5px;

                .quill-editor {
                    .ql-toolbar.ql-snow {
                        background: #f1f1f1 !important;
                        border-radius: 4px 4px 0px 0px;
                        border: none;
                    }

                    .ql-container.ql-snow {
                        height: 200px;
                        max-height: 200px;
                        min-height: 200px;
                        background: #f1f1f1;
                        border-radius: 0px 0px 4px 4px;
                        overflow: hidden;
                        border: none !important;
                    }
                }
            }

            .editor-task-new-checklist {
                width: 100%;
                height: 100%;
                background-color: #fff;
                border-radius: 5px;
                margin-top: 20px;

                .checklist-data {
                    width: 100%;

                    .ant-progress-success-bg,
                    .ant-progress-bg {
                        background-color: #ec4b1d !important;
                    }

                    .kanban-checkbox {
                        .ant-checkbox-inner {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            width: 20px;
                            height: 20px;

                            &::after {
                                border: 2px solid #fff;
                                left: 20%;
                                width: 7px;
                                height: 11px;
                                border-top: 0;
                                border-left: 0;
                            }
                        }

                        .ant-checkbox.ant-checkbox-checked {
                            .ant-checkbox-inner {
                                border: 3px solid #ec4b1d !important;
                                background-color: #ec4b1d !important;
                            }
                        }

                        .ant-checkbox-checked::after {
                            border: 1px solid #ec4b1d !important;
                        }

                        .ant-checkbox-wrapper:hover .ant-checkbox-inner,
                        .ant-checkbox:hover .ant-checkbox-inner,
                        .ant-checkbox-input:focus + .ant-checkbox-inner {
                            border: 1px solid #ec4b1d !important;
                        }
                    }
                }
            }

            .editor-task-attach-files {
                width: 100%;
                height: 100%;
                background-color: #fff;
                margin-top: 20px;
                padding-bottom: 20px;
                border-bottom: 1px solid #dddddd;

                .attach-files {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width: 240px;
                    border: 1px solid #f1f1f1;
                    padding: 3px 20px;
                    border-radius: 10px;
                    margin-top: 15px;
                    font-weight: bold;

                    .text {
                        display: flex;
                        align-items: center;
                        gap: 10px;
                    }

                    .logo svg {
                        width: 40px;
                    }
                }
            }

            .editor-task-new-subtask {
                width: 100%;
                height: 100%;
                background-color: #fff;
                margin-top: 20px;
                padding-bottom: 20px;
            }
        }
    }

    .editor-info {
        width: 30%;
        height: 100vh;
        background-color: #fff;
        border-left: 2px solid #dddddd;

        .info-task-list {
            display: flex;
            flex-direction: column;
            height: 100%;
            border-bottom: 1px solid #dddddd;
            padding: 20px;

            .info-task-item {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                padding: 10px 0;
                border-bottom: 1px solid #dddddd;

                label {
                    font-size: 14px;
                    font-weight: 500;
                    color: #333333;
                }

                .info-task-item-value {
                    font-size: 14px;
                    font-weight: 400;
                    color: #333333;
                }
            }
        }
    }
}
</style>
